/* ELEPHANT CAFE — theme.js : navigation, menu tabs, scroll reveal */
(function () {
  'use strict';

  /* ---- Mobile navigation ----
     The drawer is a full sheet, so the page behind it is locked and Escape
     closes it. Tapping any link closes it too. */
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    var drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.setAttribute('data-drawer-open', open ? 'true' : 'false');
      var bar = document.querySelector('.bookbar');
      if (bar && open) bar.setAttribute('data-hidden', 'true');
      if (open) {
        var first = drawer.querySelector('a');
        if (first) first.focus({ preventScroll: true });
      }
    }

    btn.addEventListener('click', function () {
      setOpen(drawer.getAttribute('data-open') !== 'true');
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-nav-close]')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        setOpen(false);
        btn.focus();
      }
    });
  });

  /* ---- Thumb-zone action bar ----
     Hidden while the booking form is on screen so it can never sit on top of
     the submit button, and while the page is still at the very top where the
     hero's own CTA is already visible. */
  (function () {
    var bar = document.querySelector('.bookbar');
    if (!bar) return;
    document.body.setAttribute('data-bookbar', 'true');

    var form = document.getElementById('book');
    var formVisible = false;

    if (form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        formVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.12 }).observe(form);
    }

    function update() {
      var drawerOpen = document.body.getAttribute('data-drawer-open') === 'true';
      var atTop = window.scrollY < 240;
      bar.setAttribute('data-hidden', (formVisible || drawerOpen || atTop) ? 'true' : 'false');
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    update();
  })();

  /* ---- Party size stepper ---- */
  document.querySelectorAll('.stepper').forEach(function (stepper) {
    var input = stepper.querySelector('[data-stepper-input]');
    if (!input) return;

    function clamp(n) {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 40;
      return Math.min(max, Math.max(min, n));
    }

    function sync() {
      var n = parseInt(input.value, 10) || 0;
      stepper.querySelectorAll('[data-step]').forEach(function (b) {
        var next = n + parseInt(b.getAttribute('data-step'), 10);
        b.disabled = next !== clamp(next);
      });
    }

    stepper.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(input.value, 10) || 0;
        input.value = clamp(n + parseInt(b.getAttribute('data-step'), 10));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        sync();
      });
    });

    input.addEventListener('change', function () {
      if (input.value) input.value = clamp(parseInt(input.value, 10) || 1);
      sync();
    });

    sync();
  });

  /* Menu category tabs */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));

    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (next === null) return;
        e.preventDefault();
        var target = tabs[(next + tabs.length) % tabs.length];
        target.focus();
        select(target);
      });
    });
  });

  /* Hero location switch — swaps the image and the status pill */
  document.querySelectorAll('[data-hero-switch]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-venue]');
      if (!btn) return;
      var key = btn.getAttribute('data-venue');
      group.querySelectorAll('button[data-venue]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var hero = group.closest('[data-hero]');
      if (!hero) return;
      hero.querySelectorAll('[data-venue-media]').forEach(function (m) {
        m.hidden = m.getAttribute('data-venue-media') !== key;
      });
      var pill = hero.querySelector('[data-status-for]');
      if (pill) {
        pill.setAttribute('data-status-for', key);
        document.dispatchEvent(new CustomEvent('elephant:status'));
      }
    });
  });

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }
})();
